import { UnitOfMeasureTypes } from '../enumerations/unit-of-measure-type';

export function validateVolume(unitOfMeasure?: string): boolean {
  if (!unitOfMeasure) {
    return false;
  }
  return (
    unitOfMeasure === UnitOfMeasureTypes.Litre ||
    unitOfMeasure === UnitOfMeasureTypes.GallonImperial ||
    unitOfMeasure === UnitOfMeasureTypes.GallonLiquid
  );
}
